import { FC, useRef } from 'react'

import SC from 'styled-components'

import { TableButton } from '../Buttons'

//region Styled

const FileInput = SC.input.attrs((props) => ({
  type: 'file',
  id: props.id,
  accept: props.accept,
  multiple: props.multiple
}))`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  &:focus + label {
    outline: 4px solid #7b7b7b;
  }
`

//endregion

interface Props {
  id: string
  acceptFiles: string
  multiple?: boolean
  onChange: (files: any) => void
}

export const UploadButton: FC<Props> = ({ id, acceptFiles, multiple = false, onChange }) => {
  const ref = useRef<HTMLInputElement>(null)
  return (
    <>
      <FileInput ref={ref} id={id} accept={acceptFiles} multiple={multiple} onChange={onChange} />
      <TableButton face={'neutral'} onClick={() => ref.current?.click()}>
        UPLOAD
      </TableButton>
    </>
  )
}
